import React from 'react';

export default class NoAccess extends React.Component {
    render() {
        return (
            <div>
                <h1>Access Denied</h1>
                <div>
                    The page you're trying to access has restricted access. Please contact Treez for
                    additional information.
                </div>
            </div>
        );
    }
}
